import React from "react";
import { createIcon } from "@chakra-ui/react";

const displayName = `Logo`;

const viewBox = `0 0 55 40`;

const path = (
  <>
    <path
      d="M14.68,37.69a14.71,14.71,0,1,1,0-29.41A2.71,2.71,0,0,1,17.39,11h0a2.71,2.71,0,0,1-2.71,2.71h0A9.29,9.29,0,1,0,24,23a2.71,2.71,0,1,1,5.42,0,14.71,14.71,0,0,1-14.7,14.7"
      style={{
        fill: `#ebebe6`,
      }}
    />
    <path
      d="M39.84,29.42a2.71,2.71,0,0,1-2.71-2.72h0A2.71,2.71,0,0,1,39.84,24a9.29,9.29,0,1,0-9.28-9.29,2.71,2.71,0,0,1-2.71,2.72h0a2.72,2.72,0,0,1-2.72-2.71h0A14.71,14.71,0,1,1,39.84,29.42"
      style={{
        fill: `#ebebe6`,
      }}
    />
  </>
);

export const LogoSmall = createIcon({ displayName, viewBox, path });
